import React, { useState } from "react";

const LabServicesAccordion = ({ services, openIndex, onToggle }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section className="w-full bg-white mt-[50px] 2xl:mt-[80px]">
      <div className="max-w-[1920px] mx-auto ">
        <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] leading-tight font-extrabold text-[#1a3673] text-center font-bricolage mb-16">
          Lab Service <br /> Categories Tests
        </h2>

        <div className=" border-t border-[#1a3673]/20">
          {services.map((service, index) => {
            // Changed: isExpanded is now a simple comparison
            const isExpanded = openIndex === index;
            const isHovered = hoveredIndex === index;

            return (
              <div
                key={index}
                className="border-b border-[#1a3673]/20 relative"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {/* --- Floating Image (Only on Hover) --- */}
                {isHovered && service.image && (
                  <div className="absolute left-[60%] md:left-[50%] 2xl:left-[25%] top-[50px] md:top-[-20px] z-50 pointer-events-none animate-in fade-in zoom-in duration-300">
                    <div className="relative">
                      <div className="overflow-hidden">
                        <img
                          src={service.image}
                          className="w-[80px] h-[80px] md:w-[120px] md:h-[120px] 2xl:w-[218px] 2xl:h-[218px] object-cover transition-transform duration-[3000ms] hover:scale-110"
                          alt="preview"
                        />
                      </div>
                    </div>
                  </div>
                )}

                <button
                  onClick={() => onToggle(index)}
                  className={`flex justify-between items-center w-full py-[30px] 2xl:py-10 px-[20px] 2xl:px-[50px] transition-all duration-300 group ${
                    isExpanded ? "bg-white" : "hover:bg-gray-50/50"
                  }`}
                >
                  <div className="flex items-center gap-6">
                    <h3
                      className={`font-bold text-[#1a3673] font-bricolage text-left leading-normal transition-all duration-300 ${
                        isExpanded
                          ? "text-[20px] md:text-[24px] 2xl:text-[50px] max-w-[586px]"
                          : "text-[18px] md:text-[20px] 2xl:text-[30px] max-w-[386px]"
                      }`}
                    >
                      {service.title}
                    </h3>
                  </div>

                  <div
                    className={`w-6 h-6 lg:w-12 lg:h-12 rounded-full border border-[#1a3673] flex items-center justify-center transition-all duration-300 ${
                      isExpanded ? "bg-[#1a3673] text-white" : "text-[#1a3673]"
                    }`}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      className={`transition-transform duration-300 ${
                        isExpanded ? "rotate-45" : ""
                      }`}
                    >
                      <line x1="7" y1="17" x2="17" y2="7"></line>
                      <polyline points="7 7 17 7 17 17"></polyline>
                    </svg>
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    isExpanded
                      ? "max-h-[500px] opacity-100 pb-12"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-4 flex flex-col lg:flex-row items-start gap-12">
                    <div className="lg:ml-[35%] flex-1">
                      <p className="text-[#1a3673]/80 text-[16px] 2xl:text-[24px] font-medium max-w-[90%]">
                        {service.description ||
                          "Default service description..."}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LabServicesAccordion;
